import {WorkspaceSidebar} from "@src/components/workspace-sidebar";
import {
  createFileRoute,
  Outlet,
  redirect,
  useMatches,
  useParams,
} from "@tanstack/react-router";
import {SidebarInset, SidebarProvider} from "@zeg/ui/Sidebar";

export const Route = createFileRoute("/_auth/_work-layout/$workspaceSlug")({
  beforeLoad: async ({context, params}) => {
    const {workspaceSlug} = params;
    const userWorkspaces = context.auth.profiles.map(
      (profile) => profile.$workspace?.slug
    );
    if (!userWorkspaces.includes(workspaceSlug)) {
      throw redirect({to: "/"});
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const accumulatedContext = useMatches({
    select: (matches) => matches[matches.length - 1].context,
  });
  const {workspaceSlug} = useParams({
    from: "/_auth/_work-layout/$workspaceSlug",
  });

  return (
    <SidebarProvider className="bg-secondary" enableKeyboardShortcut={true}>
      <WorkspaceSidebar
        authContext={accumulatedContext.auth}
        params={workspaceSlug}
      />
      <SidebarInset>
        <Outlet />
      </SidebarInset>
    </SidebarProvider>
  );
}
